import '@/services/feature-toggle/feature-toggle';

import registerNpsElement from '@/modules/nps/register-nps-element';
import { RegisterGlobalComponents } from './register-global-components';

registerNpsElement();
RegisterGlobalComponents.register();
